<template>
  <div class="commonDialogBody">
           <!-- <OrganizationalStructure @AllData="getMsgFormSon" style="display:none" /> -->
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;" >
    <el-form-item label="作废日期" >
        <el-date-picker
            v-model="refundTime"
            type="datetime"
            @change="refund()"
            placeholder="选择日期时间">
        </el-date-picker>
    </el-form-item>
    <el-form-item label="作废原因">
        <el-input v-model="scrapDes" size="small" ></el-input>
    </el-form-item>
</el-form>
   <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import OrganizationalStructure from "../common/OrganizationalStructure.vue";
export default {
 components: {},
  name: "ElseChargeDialog",
  //  props:['formLabelAlign'],
  data() {
    return {
     dialogVisible: false,
     title:"标题",
     labelPosition:'right',
     formLabelAlign:{},
     receiptType:[],
     receiptTypevalue:"",
     RoomNature:[],
     RoomNaturevalue:"",
     BillDateTime:"",
     repairDateTime:"",
     modulationTime:"",
     adjust:"",
    
     ArrList:[],
     BillType:[],
     BillTypevalue:"",

     BillBookNum:[],
     BillBookNumvalue:"",

     BillCode:[],
     BillCodevalue:"",

     refundType:[],
     refundTypevalue:"",

     refundTime:"",
     refundDateTime:"",

     scrapDes:"",

     user:"",




    };
  },
  methods: {
      getMsgFormSon(){

      },
    repairDate(repairDateTime){
        // console.log(repairDateTime)
    },
    inDateTime(){

    },
    modulation(){

    },
    ChangeRoomNature(){

    },
    ChangereceiptType(){

    },
    ChangeBillType(BillTypevalue){
        // console.log(BillTypevalue)
    },
    ChangeBillBookNum(BillBookNumvalue){
        // console.log(BillBookNumvalue)
    },
    ChangeBillCode(BillCodevalue){
        // console.log(BillCodevalue)
    },
    ChangerefundType(refundTypevalue){
        // console.log(refundTypevalue)
    },
    modification(){
        // 确定
        let user = localStorage.getItem("userName")
        this.user = JSON.parse(user)
        let obj = {
            "id":this.formLabelAlign.invoiceId,
            "scrapDate":this.refundDateTime,
            "scrapDes":this.scrapDes,
            "scrapMan":this.user.name
        }
          this.$http.post("/charge/web/chargeBills/otherCancel",obj).then((res) => {
             if(res.data.code == 200){
              this.dialogVisible = false
              this.$emit("Visible",false)
               this.$message({
                  type: 'success',
                  message: '作废成功!'
              });
            }
        }).catch(()=>{
            this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    refund(){
        let date = this.refundTime;
        let year = date.getFullYear();
        let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
        let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
        let hh = date.getHours() < 10 ? '0' + date.getHours():date.getHours()
        let mf = date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes()
        let ss = date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds()
        let arr = ['星期天','星期一','星期二','星期三','星期四','星期五','星期六'];
        let day = date.getDay();
        let time = year+"-"+month+"-"+dates+" "+hh+":"+mf+":"+ss
        this.refundDateTime = date.getTime()
    },

    handleClose(done) {
      this.dialogVisible = false
    },
  },
    mounted() {
  }
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>